import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';

class FooterComponent {
    constructor() {
        this.style = '';
        this.styleClass = '';
        this.content = '';
        this.type = 'text';
        this.links = [];
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: FooterComponent, selector: "ap-footer", inputs: { style: "style", styleClass: "styleClass", content: "content", type: "type", links: "links" }, ngImport: i0, template: `
    <footer class="ap-footer {{styleClass}}" style="{{style}}">
      <div class="ap-footer-content" [innerHtml]="content"></div>
      <div *ngIf="type==='links'&&links.length" class="ap-footer-link-group">
        <div *ngFor="let item of links; last as isLast;" class="ap-footer-link">
          <a *ngIf="item.href||!item.routerLink" class="ap-link" [attr.href]="item.href" [target]="item.target?item.target:'_blank'">{{item.name}}</a>
          <a *ngIf="!item.href&&item.routerLink" class="ap-link" [routerLink]="item.routerLink" [target]="item.target?item.target:'_blank'">{{item.name}}</a>
          <span *ngIf="!isLast" class="ap-footer-divider">|</span>
        </div>
      </div>
    </footer>
  `, isInline: true, styles: [".ap-footer{font-size:.875rem;color:var(--color-text-heading);line-height:1.25rem;letter-spacing:-.0125rem}.ap-footer .ap-footer-link-group{display:flex;flex-wrap:wrap}.ap-footer .ap-footer-link-group .ap-footer-link .ap-footer-divider{margin:0 var(--spacing-4);height:1.25rem}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ap-footer', template: `
    <footer class="ap-footer {{styleClass}}" style="{{style}}">
      <div class="ap-footer-content" [innerHtml]="content"></div>
      <div *ngIf="type==='links'&&links.length" class="ap-footer-link-group">
        <div *ngFor="let item of links; last as isLast;" class="ap-footer-link">
          <a *ngIf="item.href||!item.routerLink" class="ap-link" [attr.href]="item.href" [target]="item.target?item.target:'_blank'">{{item.name}}</a>
          <a *ngIf="!item.href&&item.routerLink" class="ap-link" [routerLink]="item.routerLink" [target]="item.target?item.target:'_blank'">{{item.name}}</a>
          <span *ngIf="!isLast" class="ap-footer-divider">|</span>
        </div>
      </div>
    </footer>
  `, encapsulation: ViewEncapsulation.None, styles: [".ap-footer{font-size:.875rem;color:var(--color-text-heading);line-height:1.25rem;letter-spacing:-.0125rem}.ap-footer .ap-footer-link-group{display:flex;flex-wrap:wrap}.ap-footer .ap-footer-link-group .ap-footer-link .ap-footer-divider{margin:0 var(--spacing-4);height:1.25rem}\n"] }]
        }], ctorParameters: () => [], propDecorators: { style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], content: [{
                type: Input
            }], type: [{
                type: Input
            }], links: [{
                type: Input
            }] } });
class FooterModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: FooterModule, declarations: [FooterComponent], imports: [CommonModule,
            RouterModule], exports: [FooterComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FooterModule, imports: [CommonModule,
            RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FooterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FooterComponent],
                    imports: [
                        CommonModule,
                        RouterModule
                    ],
                    exports: [FooterComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FooterComponent, FooterModule };
